module.exports = __webpack_public_path__ + "img/combo-image.6bc4b98f.jpg";